import { render, staticRenderFns } from "./pointsPopup.vue?vue&type=template&id=1c8bbdc6&scoped=true&"
import script from "./pointsPopup.vue?vue&type=script&lang=js&"
export * from "./pointsPopup.vue?vue&type=script&lang=js&"
import style0 from "./pointsPopup.vue?vue&type=style&index=0&id=1c8bbdc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8bbdc6",
  null
  
)

export default component.exports